import React from 'react';
import { IconButton, makeStyles, Tooltip } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/CheckOutlined';
import clsx from 'clsx';

const ColorSelector = ({
  color,
  onClick,
  selected = false,
  nonInteractive = false,
  iconClass = {},
  size = 50,
  ...props
}) => {
  const classes = useStyles({ nonInteractive, size });
  const MULTICOLOR = `linear-gradient(
    90deg,
    rgba(255, 0, 0, 1) 0%,
    rgba(255, 154, 0, 1) 10%,
    rgba(208, 222, 33, 1) 20%,
    rgba(79, 220, 74, 1) 30%,
    rgba(63, 218, 216, 1) 40%,
    rgba(47, 201, 226, 1) 50%,
    rgba(28, 127, 238, 1) 60%,
    rgba(95, 21, 242, 1) 70%,
    rgba(186, 12, 248, 1) 80%,
    rgba(251, 7, 217, 1) 90%,
    rgba(255, 0, 0, 1) 100%
  )`;

  return (
    <Tooltip title={color.name} classes={{ tooltip: classes.tooltip }}>
      <IconButton
        onClick={() => (nonInteractive ? true : onClick(color))}
        className={clsx(classes.colorButton, iconClass)}
        style={
          color.hex === '#gggggg'
            ? { background: MULTICOLOR }
            : { backgroundColor: color.hex }
        }
        {...props}
      >
        <CheckIcon
          style={{ opacity: selected ? 1 : 0 }}
          stroke="white"
          stroke-width={1}
          fontSize="small"
        />
      </IconButton>
    </Tooltip>
  );
};

const useStyles = makeStyles(theme => ({
  tooltip: {
    fontSize: 14
  },
  colorButton: {
    width: ({ size }) => `${size}px`,
    height: ({ size }) => `${size}px`,
    borderRadius: '25px',
    margin: theme.spacing(1),
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: theme.palette.grey[200],
    transition: 'transform 100ms ease-out',
    '&:hover': {
      transform: ({ nonInteractive }) =>
        nonInteractive ? 'scale(1)' : 'scale(1.3)'
    },
    '& > span': {
      width: ({ size }) => `${size / 2}px`,
      height: ({ size }) => `${size / 2}px`
    }
  }
}));

export default ColorSelector;
